var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnquiryfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Enquiry_-_Fi_",
    "data-name": "Enquiry - Fi;;",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 18,
    viewBox: "0 0 16.2 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M5.7,3.8V7.4H16.5V3.8h1.806a.894.894,0,0,1,.894.894V19.106a.894.894,0,0,1-.894.894H3.894A.894.894,0,0,1,3,19.106V4.694A.894.894,0,0,1,3.894,3.8ZM8.4,15.5H6.6v1.8H8.4Zm0-2.7H6.6v1.8H8.4Zm0-2.7H6.6v1.8H8.4ZM14.7,2V5.6H7.5V2Z",
    transform: "translate(-3 -2)",
    fill: "#002d44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryfill);
export default __webpack_public_path__ + "static/media/enquiryfill.a5f63f568396d5cf584e1225473617fa.svg";
export { ForwardRef as ReactComponent };